import { useQuery as useApolloQuery } from '@apollo/client/react';
import { GET_ORGANIZATION_LEGAL_SLUG } from '../../../lib/graphql/queries/organizations';

interface LegalSlugData {
  organization: { organizationId: string; legalSlug: string | null } | null;
}

/**
 * The org's saved legal pages slug (SPEC-2782). `available` is false while the API predates the
 * field, so callers can hide the setting instead of breaking.
 */
export const useOrganizationLegalSlug = (organizationId: string | undefined, enabled: boolean) => {
  const { data, loading, error, refetch } = useApolloQuery<LegalSlugData>(GET_ORGANIZATION_LEGAL_SLUG, {
    variables: { organizationId: organizationId ?? '' },
    skip: !enabled || !organizationId,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  return {
    legalSlug: data?.organization?.legalSlug ?? null,
    loading,
    available: !error && !!data?.organization,
    refetch,
  };
};
